export const compareByNaturalSortOrder = (a?: string, b?: string): -1 | 0 | 1 => {
  const comparedVal = (a ?? '').toLowerCase().localeCompare((b ?? '').toLowerCase(), undefined, { numeric: true });
  // localeCompare may return non 0/-1/1 values, but CDS sorting requires these values.
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/localeCompare#description
  if (comparedVal === 0) {
    return comparedVal;
  }
  return comparedVal > 0 ? 1 : -1;
};
